import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';

export const StyledQ = styled.dt`
  cursor: pointer;
  position: relative;
  padding: ${themeGet('scale.scaleUp03')};
  font-family: "Whitney SSm A", "Whitney SSm B", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: ${themeGet('scale.scaleUp02')};
  font-weight: ${themeGet('fontWeight.fontWeightMedium')};
  line-height: normal;
  color: ${themeGet('color.colorBlue')};
  outline: none;

  @media (max-width: ${themeGet('breakpoint.breakpointTablet')}) {
    padding-right: ${themeGet('scale.scaleUp10')};
    font-size: ${themeGet('scale.scaleUp01')};
  }

  .arrow {
    position: relative;
    top: -3px;
    display: inline-block;
    width: 11px;
    height: 11px;
    margin-left: 11px;
    border-color: ${themeGet('color.colorBlue')};
    border-style: solid;
    border-width: 0 ${themeGet('scale.scaleDown05')}
      ${themeGet('scale.scaleDown05')} 0;
    transform: rotate(45deg);

    @media (max-width: ${themeGet('breakpoint.breakpointTablet')}) {
      position: absolute;
      top: 50%;
      right: ${themeGet('scale.scaleUp03')};
      margin-top: -5px;
    }
  }

  &[aria-expanded='true'] .arrow {
    top: 1px;
    border-width: ${themeGet('scale.scaleDown05')} 0 0
      ${themeGet('scale.scaleDown05')};

    @media (max-width: ${themeGet('breakpoint.breakpointTablet')}) {
      top: 50%;
      margin-top: -2px;
    }
  }
`;

export const StyledA = styled.dd`
  overflow: hidden;

  > div > div {
    padding: 0 ${themeGet('scale.scaleUp03')} ${themeGet('scale.scaleUp03')};
  }

  p {
    margin-bottom: ${themeGet('scale.scaleUp03')};
    font-size: ${themeGet('scale.scaleBase')};
    line-height: 1.7;

    &:last-of-type {
      margin-bottom: 0;
    }

    @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
      font-size: ${themeGet('scale.scaleUp01')};
    }
  }
`;

export const StyledDiv = styled.div`
  margin: ${themeGet('scale.scaleBase')} 0;
  border: ${themeGet('scale.scaleDown05')} solid
    ${themeGet('color.colorGrayBlue40')};
  border-radius: 3px;

  &:hover {
    background-color: ${themeGet('color.colorBlueLightest')};
    border-color: ${themeGet('color.colorBlueDark')};

    ${StyledQ} {
      color: ${themeGet('color.colorBlueDark')};

      .arrow {
        border-color: ${themeGet('color.colorBlueDark')};
      }
    }
  }

  &[aria-expanded='true'] {
    &:hover {
      background-color: ${themeGet('color.colorWhite')};
      border-color: ${themeGet('color.colorGrayBlue40')};
    }
  }
`;
